<template>
    <!-- Il carosello della homepage -->
    <div>
        <b-carousel
        id="carousel-1"
        :interval="3000"
        controls
        indicators
        no-hover-pause
        background="#ababab"
        :img-width="620"
        :img-height="350"
        >
            <!-- Visualizzo le slides con i links-->
            <div v-for="(slide, index) in slides" :key="index">

                <!-- la slide ha un'azione al click associata, questa ha precedenza sulla route eventualmente associata -->
                <b-link v-if="slide.click_action !== null" @click.prevent="manage_javascript_action(slide.id, slide.click_action)">
                    <b-carousel-slide  :img-src="slide.img_path"></b-carousel-slide>
                </b-link>

                <!-- La slide ha una route associata, ma non un'azione al click -->
                <b-link v-else-if="slide.route_name !== null" :to="slide.route_name" @click.prevent="click_count(slide.id)">
                    <b-carousel-slide  :img-src="slide.img_path"></b-carousel-slide>
                </b-link>

                <!-- La slide non ha ne una route associata ne un'azione al click, renderizziamo senza il b-link -->
                <b-carousel-slide v-else :img-src="slide.img_path"></b-carousel-slide>
            </div>
        </b-carousel>
    </div>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import aes from 'crypto-js/aes'
import base64 from 'crypto-js/enc-base64'
import latin1 from 'crypto-js/enc-latin1'

export default {
  name: 'CaroselloViewer',
  data () {
      return {
          // Slides da visualizzare, viene popolata con una lista di oggetti
          // del tipo:
          //  {  id: <slide_id>, img_path : <path immagine>, route_name : { name : <nome della route> } }
          // se la slide non ha una route associata la chiave route_name è null per non renderizzare il
          // link ( vedi la funzione created )
          slides : [],
          // Path delle slide
          slides_path : process.env.BASE_URL + 'storage/img_carosello/'
      }
  },
  methods: {
      /**
       * Al click sulla chiama la funzione di backend che incrementa il conteggio
       * click della slide.
       */
      click_count : function ( slide_id ) {
        axios.post( apiUrl.welfareapi.carosello_click_count, { slide_id : slide_id } )
        .then( (response) => {
            // Non dobbiamo fare nulla qui!
        })
        .catch( (error) => {
            // Ci limitiamo a loggare l'errore nella console.
            console.error( error.response.data );
        })
      },
      /**
       * Al click sulle diapositive per la quale è stata definita un'azione javascript da eseguire,
       * esegue il codice e poi richiama la funzione click_count per aggiornare il conteggio dei
       * click.
       */
      manage_javascript_action : function ( slide_id, jscode ) {

        // Decriptiamo il codice javascript inviato dal backend, come riferimento riadattiamo
        // il codice visto qui:
        // https://stackoverflow.com/questions/54501320/decodebase64-and-decryptaes-cbc-pkcs5padding-with-cryptojs-react
        // In tal modo se qualcuno provasse ad iniettare del suo codice dovrebbe conoscere la chiave per poterlo
        // correttamente decodificare ed eseguire.
        let key = latin1.parse(process.env.VUE_APP_CR_KEY);
        let iv  = latin1.parse(process.env.VUE_APP_CR_IV);
        let plaintextData = aes.decrypt( { ciphertext: base64.parse( jscode ) }, key, { iv: iv } );
        let decrypted_code = plaintextData.toString( latin1 );

        // Ref: https://stackoverflow.com/questions/4183591/new-function-with-variable-parameters
        // Creiamo una funzione con il codice preso dal db, il quale deve essere posto per
        // ultimo nell'array degli argomenti e con due variabili che andiamo a passargli:
        // - vue :      è il nome della variabile che rappresenta nella funzione su db
        //              l'istanza di vue con la quale possiamo fare le nostre operazioni.
        // - slide_id : è il nome della variabile che rappresenta l'id della slide che
        //              stiamo cliccando nella funzione su db.
        const f  = Function.apply( null, [ 'vue', 'slide_id', decrypted_code ] );

        // Richiamiamo la funzione appena creata passando le due variabili definite in precedenza
        // this.$root è infatti l'istanza di vue di questa applicazione.
        f( this.$root, slide_id );

        // Aggiorniamo il conteggio dei click.
        this.click_count( slide_id );

      }
  },
  /**
   * Carica la sequenza di slides per l'azienda di cui l'utente fa parte.
   */
  created : function () {
    axios.get( apiUrl.welfareapi.carosello_get_playlist )
    .then( (response) => {

        for ( let elem of response.data ) {

            // Se la route non è definita l'oggetto che la descrive è null
            // per impedire di renderizzare il click
            let route_obj = null;
            if ( elem.menu_key !== null && elem.menu_key !== '' ) {
                route_obj = { name : elem.menu_key }
            }

            // Facciamo la stessa cosa con l'eventuale azione da eseguire al click
            // la quale ha precedenza sull'eventuale route impostata, impostiamo
            // l'azione a null per impedire di renderizzare la diapositiva in questa
            // modalità se non richiesto.
            let click_action = null;
            if ( elem.on_click_action !== null && elem.on_click_action !== '' ) {
                click_action = elem.on_click_action;
            }

            this.slides.push ( { id : elem.id,
                                 img_path : this.slides_path + elem.file_name,
                                 route_name : route_obj,
                                 click_action : click_action
                            } );
        }
    })
    .catch( (error) => {
      generalLib.backend_error_message_box( this, error.response.data );
    })
  }
}
</script>

<style scoped>
/* Modifichiamo il colore delle frecce destra sinistra, siccome sono prese da un set di icone
   della w3.org andiamo a modificare il parametro fill dell'url.*/
#carousel-1 :deep( .carousel-control-next-icon ) {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%232e96c9' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
}
#carousel-1 :deep( .carousel-control-prev-icon ) {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%232e96c9' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
}
/* Togliamo la trasparenza alle frecce destra sinistra quando non siamo in hovering */
#carousel-1 :deep( .carousel-control-next ) {
    opacity: 1;
}
#carousel-1 :deep( .carousel-control-prev ) {
    opacity: 1;
}
/* Modifichiamo il colore delle barrette sotto che indicano a quale slide siamo arrivati */
#carousel-1 :deep( .carousel-indicators li ) {
    background-color: #2e96c9;
}
</style>